import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { DirectivesModule } from './../Directives/Directives.module';
import { PeekPanelComponent } from './PeekPanel.component';
import { PeekRootComponent } from './PeekRoot.component';

@NgModule({
    imports: [CommonModule, CoreUiModule, DirectivesModule],
    declarations: [PeekPanelComponent, PeekRootComponent],
    exports: [PeekPanelComponent, PeekRootComponent],
    providers: []
})
export class PeekModule {}
